/*
 * -----------------------------------------------------------------------
 *  <copyright file="image-service.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

const GetMimeType = (b64: string) => {
    const signatures = {
        R0lGODdh: 'image/gif',
        R0lGODlh: 'image/gif',
        iVBORw0KGgo: 'image/png',
        '/9j/': 'image/jpg',
    };
    const mimeTypeKey = Object.keys(signatures).find((s: any) => b64.indexOf(s) === 0);
    return (signatures as any)[mimeTypeKey];
};

export { GetMimeType };
